import { render, staticRenderFns } from "./OfferPage.vue?vue&type=template&id=420d90ec&scoped=true&"
import script from "./OfferPage.vue?vue&type=script&lang=js&"
export * from "./OfferPage.vue?vue&type=script&lang=js&"
import style0 from "./OfferPage.vue?vue&type=style&index=0&id=420d90ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420d90ec",
  null
  
)

export default component.exports